import style from "./MessageErrorMovieNoSearch.module.css";
export const MessageErrorMovieNoSearch = () => (
  <p className={style.paragraph_no_movie}>NO SE ENCONTRARON PELICULAS</p>
);
